import type { PostSource } from '../types';

let counter = 0;
const queues = new Map<string, string[]>();

function sourceKey(source: PostSource): string {
  return `${source.type}:${source.id ?? 'na'}`;
}

export function enqueueShareToast(source: PostSource): string {
  const key = sourceKey(source);
  const toastId = `ig-share-${key}-${counter}`;

  counter += 1;
  const queue = queues.get(key) ?? [];

  queue.push(toastId);
  queues.set(key, queue);

  return toastId;
}

export function dequeueOldestShareToast(
  source: PostSource
): string | undefined {
  const key = sourceKey(source);
  const queue = queues.get(key);

  if (!queue || queue.length === 0) {
    return undefined;
  }

  const toastId = queue.shift();

  if (queue.length === 0) {
    queues.delete(key);
  }

  return toastId;
}

export function removeShareToast(toastId: string): void {
  for (const [key, queue] of queues) {
    const index = queue.indexOf(toastId);

    if (index !== -1) {
      queue.splice(index, 1);

      if (queue.length === 0) {
        queues.delete(key);
      }

      return;
    }
  }
}
